import React, { useContext, useEffect, useState } from "react";
import { Avatar, AvatarFallback, Button, Separator } from "@lemonadetraining/web-ui";
import { motion } from "motion/react";

/*-----  [Authentication imports] ------ */
import { AuthContext } from "@lemonadetraining/web-shared";
import WorkoutScore from "./WorkoutScore";
import VariantAvatarImage from "@lemonadetraining/web-shared/components/VariantAvatarImage";

const ViewScoreItem = (props) => {
  const authCtx = useContext(AuthContext);
  const [AvatarPicURL, setAvatarPicURL] = useState(props.avatar);

  useEffect(() => {
    const loadPic = async () => {
      if (props.score.athleteUID) {
        authCtx
          .getProfilePicURL(props.score.athleteUID)
          .then((url) => {
            setAvatarPicURL(url);
          })
          .catch((error) => {
            // Silently handle missing profile pictures - they'll use default avatar
            console.debug("Profile picture not found for user:", props.score.athleteUID);
          });
      }
    };

    loadPic();
  }, [authCtx, props.score.athleteUID]);

  return (
    <motion.div
      style={{ display: "flex", flexDirection: "column", width: "auto", height: "auto" }}
      variants={{
        hidden: (i) => ({
          opacity: 0,
          y: -50 * i,
        }),
        visible: (i) => ({
          opacity: 1,
          y: 0,
          transition: {
            delay: i * 0.05,
          },
        }),
      }}
      initial="hidden"
      animate="visible"
      key={props.idx}
      custom={props.idx}
    >
      <div className="flex flex-row gap-1 items-center mr-1">
        <Avatar className="h-10 w-10">
          <VariantAvatarImage src={AvatarPicURL} alt="Coach Pic" />
          <AvatarFallback>?</AvatarFallback>
        </Avatar>
        <Button size="sm" variant="outline">
          {props.score.athleteName}
        </Button>
      </div>
      <WorkoutScore viewOnly score={props.score} scoreType={props.score.scoreType} />
      <Separator className="mt-2" />
    </motion.div>
  );
};

export default ViewScoreItem;
